import { Dialog, DialogType, PrimaryButton, Stack, TextField } from "@fluentui/react";
import "./CreateVoting.css";
import { createNewVoting } from "../../Services/VoteService";
import { useState } from "react";

type CreateVotingPopupProps = {
  userName: string | undefined;
  isNewVotingDialogVisible: boolean;
  toggleNewVotingDialog: () => void;
};

export function CreateVotingPopup({
  userName,
  isNewVotingDialogVisible,
  toggleNewVotingDialog,
}: CreateVotingPopupProps) {
  const [isCreating, setIsCreating] = useState<boolean>(false);
  const [newVotingTitle, setNewVoting] = useState<string>("");

  const handleInputChange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setNewVoting(event.currentTarget.value);
  };

  return (
    <>
      <Dialog
        hidden={!isNewVotingDialogVisible}
        onDismiss={toggleNewVotingDialog}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: "Neue Schätzung erstellen",
          styles: {
            title: {
              fontSize: "23px",
              textAlign: "center",
              color: "black",
            },
          },
        }}
        modalProps={{
          isBlocking: false,
        }}
      >
        <Stack tokens={{ childrenGap: 15 }}>
          <TextField
            label="Name"
            placeholder="Name"
            value={newVotingTitle}
            onChange={(event) => handleInputChange(event)}
          />

          <PrimaryButton
            text="Erstellen"
            onClick={() => createNewVoting(setIsCreating, newVotingTitle, userName ?? "")}
            disabled={isCreating}
          />
        </Stack>
      </Dialog>
    </>
  );
}
